import { useQuery } from "@tanstack/react-query";
import BaseLayout from "@/v2/components/BaseLayout";
import ArticleCard from "@/v2/components/ArticleCard";
import { fetchLatestArticles } from "@/v2/queries";

export default function HomePage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["v2", "home"],
    queryFn: () => fetchLatestArticles(30),
  });

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "Korthet",
      url: "https://korthet.se/",
      inLanguage: "sv-SE",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://korthet.se/sok?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Korthet",
      url: "https://korthet.se/",
      email: "hello@korthet.se",
    },
  ];

  return (
    <BaseLayout
      title="Korthet – Nyheter i korthet"
      description="Sveriges snabbaste sätt att ta till sig dagens nyheter. AI sammanfattar, du väljer vad du vill läsa vidare."
      canonicalPath="/"
      jsonLd={jsonLd}
    >
      <h1 className="k2-h1">Senaste nyheterna</h1>
      {isLoading && <p className="k2-loading">Laddar…</p>}
      {error && (
        <p className="k2-error">Kunde inte hämta artiklar just nu.</p>
      )}
      {data && data.length === 0 && (
        <p className="k2-empty">Inga artiklar publicerade ännu.</p>
      )}
      {data && data.length > 0 && (
        <ul className="k2-feed">
          {data.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </ul>
      )}
    </BaseLayout>
  );
}